 
export default{ 
    data() {
        return {
            currKey:'',
            currType:'',
            currTaskKey:'',
        }
    },
    props: {
        visible: { 
          type: Boolean,
          default: false
        }, 
        bizKey:String,
        bizType:Number,
        taskKey:String
    },
    watch: {
        bizKey() { 
            this.init();
        }, 
    },  
    mounted() { 
    },                     
    methods: {
        init(){  
            this.currKey=this.bizKey;
            this.currType=this.bizType;
            this.currTaskKey=this.taskKey;
        } ,
        changeBiz(bizKey,bizType){ 
            this.currKey=bizKey;
            this.currType=bizType;
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/basics/docInfo/src/info.js